import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurgicalTreatmentComponent } from './surgical-treatment.component';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TdoControlsModule } from 'src/app/tdo-controls/tdo-controls.module';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
  declarations: [SurgicalTreatmentComponent],
  imports: [CommonModule,
    DirectivesModule,
    MatCheckboxModule,
    TdoControlsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatRadioModule],
  exports: [SurgicalTreatmentComponent]
})
export class SurgicalTreatmentModule {} 